import { render } from "./ordertag.vue?vue&type=template&id=4226de74&scoped=true"
import script from "./ordertag.vue?vue&type=script&lang=js"
export * from "./ordertag.vue?vue&type=script&lang=js"

import "./ordertag.vue?vue&type=style&index=0&id=4226de74&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4226de74"]])

export default __exports__